import $ from 'jquery';

import { View } from 'backbone';

import _Template from 'designer/layout-toolbar-pane.ejs';
import Immutable from 'immutable';
import listService from 'ListService.js';
import eventBus from 'EventBus.js';
import pageSyncService from 'PageSyncService.js';
import geometryService  from 'GeometryService';
import crudController from 'CrudController.js';

import groupGenericTemplate from 'toolbox/toolbox-group.ejs';
import groupCommonTemplate from 'toolbox/toolbox-group-common.ejs';

import toolboxDesingerTemplate from 'behaviors/toolbox/toolbox-groups.ejs';
import toolboxTabsTemplate from 'behaviors/toolbox/toolbox-tabs.ejs';
import toolboxTabsReportingTemplate from 'behaviors/toolbox/toolbox-tabs-report.ejs';
import toolboxGroupsReportTemplate from 'behaviors/toolbox/toolbox-groups-report.ejs';
// PF-3527 Commented as it will be used on next versions.
// import zoomService from 'ZoomService.js'
import constants from 'Constants.js'
import toolboxItemMapService from 'ToolboxItemMapService.js';
import undoService from 'UndoService.js';
import factoryService from 'FactoryService.js';
import dragDropService from 'DragDropService.js'
import focusController from 'FocusController.js'
import textConstants from 'TextConstants';
import util from 'util/Util.js'
import CommonGroupConfigView from 'common-views/CommonGroupConfigView';
import leftPanelState   from "LeftPanelStateService";
import MobileMenuIcon  from '../../components/MobileWizard/MobileMenuIcon.js';


class BehaviorToolbarPaneView extends View {


    initialize(opts) {
        this.defaultGroup = constants.DEFAULT_TOOLBOX_GROUP;
        this.options = opts || {};
        this.template = _Template;
        this.tagName = 'div';
        this.id = opts.el;


        this.events = {
            //'click #desktopLayout, #tabletLayout, #phoneLayout' : 'changeLayout',
            'click #behaviorView,#workflowView':'handleLinkNavigation',
            'click .layout-switch': 'changeLayout',
            'click .control-tabs li a': 'changeTabs',

            /* PF-3527 Commented as it will be used on next versions.
            'click #zoom-in': 'zoomIn',
            'click #zoom-out': 'zoomOut',
            'click #actual-size': 'actualSize',
            */

            'click #deleteItem': 'deleteItem',
            'click #undoAction': 'undoAction',
            'click #redoAction': 'redoAction',
            'click #common_config': 'commonConfig',
            'drop #toolSearch': 'avoidDragAndDrop',
            'click #workflowmain': 'workflowmain',
            'click #behaviors': 'behaviors'
        };

        this.templateMap = Immutable.Map([
            ['all', groupGenericTemplate],
            ['workflow', groupGenericTemplate],
            ['objects', groupGenericTemplate],
            ['integration', groupGenericTemplate],
            ['general', groupGenericTemplate],
            ['form', groupGenericTemplate],
            ['report', groupGenericTemplate],
            ['common', groupCommonTemplate]
        ]);

        this.selectedGroupElement = this.defaultGroup;
        if (listService.docType === constants.DOC_TYPE_REPORT) {
            this.toolboxItems = toolboxItemMapService.getReportBehaviorItemsByGroup('all');
        } else {
            this.toolboxItems = toolboxItemMapService.getBehaviorItemsByGroup('all');
        }
        if (listService.docType === constants.DOC_TYPE_REPORT) {
            this.model.set('helpUrl', constants.HELP_REPORT_URL);
            this.model.set('helpUrl2', constants.HELP_REPORT_BEHAVIOR_URL);
        }else{
            this.model.set('helpUrl', constants.HELP_LAYOUT_TOOLBAR_URL);
            this.model.set('helpUrl2', constants.HELP_BEHAVIOR_URL);
        }        

        this.listenTo(eventBus, 'commonGroupUpdated', this.commonGroupUpdated);
        return this;
    }

    workflowmain(ev){
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('#workflowmain');
    }

    behaviors(ev){
        ev.preventDefault();
        leftPanelState.save();
        Backbone.history.loadUrl('#behaviors');
    }

    handleLinkNavigation(){
        listService.itemSearched = 0;
        listService.linkClicked = true;
    }

    commonGroupUpdated() {
        this.setSelectedGroup('common');
    }

    commonConfig(ev) {
        const view = new CommonGroupConfigView({ model: this.model });
        view.render();
    }

    avoidDragAndDrop() {
        return false;
    }

    undoAction() {
        undoService.undo();
        eventBus.trigger('undoCacheEvent');
    }

    redoAction() {
        undoService.redo();
        eventBus.trigger('undoCacheEvent');
    }

    deleteItem() {
        crudController.deleteSelectedBehaviors();
    }

    changeLayout(ev) {
        ev.preventDefault();
        leftPanelState.save();
        const target = ev.currentTarget;
        const layoutType = target.getAttribute('data-layout');
        listService.linkClicked = true;


        if (layoutType === 'deviceDesktop') {
            if (listService.docType === constants.DOC_TYPE_FORM) {
                Backbone.history.loadUrl('edit');
            } else {
                Backbone.history.loadUrl('report');
            }
        }
        if (listService.noPages) {
            eventBus.trigger('hideCanvas');
        } else {
            eventBus.trigger('showCanvas');
        }
        /*
        formModel.set({
            currentDevice: layoutType
        })

        this.cleanUpLayoutSwitches();
        this.drawLayout(layoutType);
        $(target).addClass('active');

        eventBus.trigger('selectForm');
        */
    }

    cleanUpLayoutSwitches() {
        const layoutSwitches = this.$el.find('.layout-switch');
        layoutSwitches.map((index, item) => { $(item).removeClass('active') })
    }

    drawLayout(layoutType) {
        // Getting the current width either the one by default or the one assigned by the user via properties.
        let currentWidth = listService.currentForm.model.attributes.formWidth;
        let currentHeight = listService.currentForm.model.attributes.formHeight;

        const mapSizes = Immutable.Map([
            ['desktopLayout', { width: currentWidth, height: currentHeight }],
            ['tabletLayout', { width: constants.TABLET_MAX_WIDTH, height: constants.TABLET_MAX_HEIGHT }],
            ['phoneLayout', { width: constants.PHONE_MAX_WIDTH, height: constants.PHONE_MAX_HEIGHT }]
        ]);

        var newSize = mapSizes.get(layoutType);
        var newHeight = newSize.height;
        var newWidth = newSize.width;

        listService.currentForm.model.attributes.formHeight = newHeight;
        listService.currentForm.model.attributes.formWidth = newWidth;

        // Saving the current layout type inside the current model of the form.
        // This is perfomed to validate the bounda of the control in the PageSyncService.
        listService.currentForm.model.attributes.currentLayout = layoutType;
        eventBus.trigger('formWidthSet', newWidth);
        eventBus.trigger('formHeightSet', newHeight);
        var currPage = listService.currentPageId;
        listService.currentPageId = 0;
        pageSyncService.displayPage(currPage);

        listService.currentForm.model.trigger('change');
    }

    /* PF-3527 Commented as it will be used on next versions.
    zoomIn(evt) {
        evt.preventDefault();
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_IN);
        let canZoom = zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_IN);
        if (canZoom) {
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_IN);
        }

    }

    zoomOut(evt) {
        evt.preventDefault();

        let canZoom = zoomService.handleAllControlsZoom(constants.SCALE_FACTOR_ZOOM_OUT);
        if (canZoom) {
            zoomService.fillZoomScaleAttribute(constants.SCALE_FACTOR_ZOOM_OUT);
        }
        zoomService.handleCanvasZoom(constants.SCALE_FACTOR_ZOOM_OUT);
    }


    actualSize(evt) {
        evt.preventDefault();
        listService.currentForm.model.attributes.zoomScale = undefined;
        const layoutType = listService.currentForm.model.attributes.currentLayout;
        this.drawLayout(layoutType);
    }

    */
    changeTabs(ev) {
        ev.preventDefault();
        const buttonName = ev.currentTarget.id;
        const tabSectionName = ev.currentTarget.name;

        this.setSelectedGroup(tabSectionName);

    }

    setSelectedGroup(sectionName) {
        this.selectedGroupElement = sectionName;
        let items = [];

        if (listService.docType === constants.DOC_TYPE_REPORT) {
            items = toolboxItemMapService.getReportBehaviorItemsByGroup(sectionName);
        } else {
            items = toolboxItemMapService.getBehaviorItemsByGroup(sectionName);
        }


        if (sectionName === 'common' && items.length) {
            let layoutItems = toolboxItemMapService.getBehaviorItemsByGroup('all');

            items.forEach(i => {
                let control = layoutItems.find(c => c.factoryKey === i.factoryKey);
                if (control)  {
                    if (control.style) {
                        i.style = control.style;
                    }

                    if (control.textStyle) {
                        i.textStyle = control.textStyle;
                    }
                }
            });
        }

        this.model.set('items', items, { silent: true });

        // reset all tab panes
        $('#factories .tab-pane').empty();

        // insert template for selected group
        var gTemplate = this.templateMap.get(sectionName);
        $('#' + sectionName).html(gTemplate(this.model.toJSON()));

        if ((items.length + 1) < constants.MAX_ITEMS_PER_SECTION_TOOLBAR){
            $(".left.carousel-control").addClass("disable_a_href");
            $(".right.carousel-control").addClass("disable_a_href");
        }

    }

    toolboxItemMatcher(toolboxItems) {
        return function findMatches(q, cb) {
            var matches, substringRegex;

            matches = [];
            let val = $('#toolSearch').val();
            substringRegex = new RegExp(val, 'i');
            $.each(toolboxItems, function (i, toolboxItem) {
                if (substringRegex.test(toolboxItem.name)) {
                    let obj = toolboxItem;
                    obj.label = toolboxItem.name;
                    matches.push(obj);
                }
            });
            cb(matches);
        };
    }

    render() {
        let self = this;
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        $("#toolSearch").on('keypress', function (e) {
            var code = (e.keyCode ? e.keyCode : e.which);
            if (code === 13) { //Enter keycode
                return false;
            }
        });

        $('ul.views-options a.layout-switch').removeClass('active');
        $('#behaviorView a').addClass('active');

        $('#toolbox-tabs').html(toolboxTabsTemplate);
        $('#factories').html(toolboxDesingerTemplate);
        if (listService.docType === constants.DOC_TYPE_REPORT) {
            $('#workflowView').remove();
            $('#toolbox-tabs').html(toolboxTabsReportingTemplate);
            $('#factories').html(toolboxGroupsReportTemplate);
        }

        this.setSelectedGroup(this.selectedGroupElement);
        let selected = false;
        let initialEdges = {};

        $(".layout-switch[data-layout='deviceTablet']").prop('disabled', 'disabled');
        $(".layout-switch[data-layout='devicePhone']").prop('disabled', 'disabled');

        $("#toolSearch").autocomplete({
            source: this.toolboxItemMatcher(this.toolboxItems),
            close: function (event, ui) {
                if (!selected) {
                    $("ul.ui-autocomplete").hide()
                }
            },
            focus: function (event, ui) {
                if ($("#factories").hasClass('disabledSection')) {
                    $("#toolSearch").autocomplete('disabled');
                    return;
                }
                let factoryKey = ui.item.factoryKey;
                let menuItems = $('li.ui-menu-item div:contains("' + ui.item.value + '")');
                initialEdges.left = event.pageX;
                initialEdges.top = event.pageY;
                initialEdges.right = event.pageX + event.currentTarget.clientWidth;
                initialEdges.bottom = event.pageY + event.currentTarget.clientHeight;

                let canvas = $(constants.PAGESEL_ID);
                let pageRect = {
                    top: -1,
                    left: -1,
                    height:  util.extractNum(canvas.height()) + 2,
                    width: util.extractNum(canvas.width()) + 2
                };

                let isInsideCanvas = false;

                _.forEach(menuItems, item => {
                    let modelItem = ui.item;

                    $('#' + item.id).draggable({
                        appendTo: 'body',
                        cursor: "move",
                        containment: "body",
                        scroll: false,
                        cursorAt: { top: 0, left: 0 },
                        helper: function (ev) {
                            // Reset drag image
                            focusController.clearAllSelected();
                            let factories = factoryService.behaviorsFactories;
                            // Identify the factory whose icon is being dragged
                            // IE9 must use currentTarget instead of target. Works with others also.
                            let iconId = modelItem.icon;
                            //PF-2486 - Form Design - Layout - Cannot Drag Asset onto canvas
                            const assetId = ev.target.getAttribute("data-asset-id");
                            const controlType = modelItem.factoryKey;

                            if (controlType) { //If factory is for an asset then controlType brings us the iconId (Control type)
                                iconId = controlType;
                            }
                            const height = factories[iconId].height;
                            const width = factories[iconId].width;

                            const dragImage = dragDropService.createRawDragGhost(height, width);
                            const $ghost = dragImage.$ghost;
                            // Second: get center point. We drag the center of the drag ghost
                            let cx = $ghost.width() / 2;
                            let cy = $ghost.height() / 2;
                            return $ghost.get(0);
                        },
                        start: function (ev, ui) {
                            $(this).draggable('instance').offset.click = {
                                left: Math.floor(ui.helper.width() / 2),
                                top: Math.floor(ui.helper.height() / 2)
                            }
                        },
                        drag: function (event, ui) {
                            if (((ui.position.top + ui.helper.height() < (initialEdges.top - (ui.helper.height() / 2))) ||
                                ((ui.position.top + ui.helper.height()) > initialEdges.bottom - (ui.helper.height() / 2))) ||
                                (((ui.position.left + ui.helper.width()) < (initialEdges.left - (ui.helper.width() / 2))) ||
                                (ui.position.left + ui.helper.width()) > (initialEdges.right - (ui.helper.width() / 2)))) {

                                    selected = true;

                                    $("ul.ui-autocomplete").hide();
                                    $("#toolSearch").val('');
                            }

                            let elemRect = {
                                left: Number(ui.position.left - util.pagePos.left),
                                top: Number(ui.position.top - util.pagePos.top),
                                width: util.extractNum(ui.helper.width()),
                                height: util.extractNum(ui.helper.height())
                            };

                            isInsideCanvas = geometryService.isValidOverlapping(pageRect, elemRect);
                            let cursor = isInsideCanvas ? "copy" : 'no-drop';

                            $(ui.helper).css('cursor', cursor);
                        },
                        stop: function (event, ui) {
                            if (isInsideCanvas) {
                                let dropY = event.pageY - util.pagePos.top - (Math.floor(ui.helper.height() / 2));
                                let dropX = event.pageX - util.pagePos.left - (Math.floor(ui.helper.width() / 2));

                                self.createControl(factoryKey, { top: dropY, left: dropX });
                                eventBus.trigger(constants.EV_REFRESH_REMOTE_DATA_FILTER);
                            }

                            selected = false;
                            $(ui.helper).css('cursor', "pointer");
                        }
                    });
                });
            }
        }).autocomplete('instance')._renderItem = function (ul, item) {
            return $("<li>")
                .append("<div><span><i style='margin-right:5px' class='fa " + item.icon + "'></i></span>" + item.label + "</div>")
                .appendTo(ul);
        };

        this.delegateEvents();

        // Mobile forms wizard.
        MobileMenuIcon.render('mobileFormsView', { activeTab: listService.activeDashboardTab });
       
        return this;
    }

    createControl(factoryKey, position) {
        const factoryParams = factoryService.behaviorsFactories[factoryKey];
        const dropPos = {
            top: position.top,
            left: position.left
        };

        const control = factoryParams.factory.createView(factoryKey, dropPos);
        undoService.add({
            undo() {
                listService.deleteBehaviorObject(control.id);
                control.unrender();
            },
            redo() {
                listService.addBehaviorObject(control.id, control);
                control.render();
            }
        }, textConstants.UNDO_NEW);

        listService.addBehaviorObject(control.id, control);
        control.render();
        control.switchProperties(control.model);
        listService.currentBehaviorId = control.model.get('id');
        //force active object
        const widget = listService.getCanvasObjectById(control.model.get('id'));
        listService.fcanvas.setActiveObject(widget);
        util.updateHelpDocumentationLink(control.model.get('factoryKey'));
        eventBus.trigger(constants.EV_DELETE_TREE_FILTER);
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.off();
        this.$el.empty();
        super.remove();
    }
}

export default BehaviorToolbarPaneView;
